/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Pricing_Start_TrialInputs */

const en_pricing_start_trial = /** @type {(inputs: Pricing_Start_TrialInputs) => LocalizedString} */ (i) => {
	const daysPlural = registry.plural("en", i?.days, {});return /** @type {LocalizedString} */ (`Start ${i?.days}-day free trial`)
};

const es_pricing_start_trial = /** @type {(inputs: Pricing_Start_TrialInputs) => LocalizedString} */ (i) => {const daysPlural = registry.plural("es", i?.days, {});
	if (daysPlural === "one") return /** @type {LocalizedString} */ (`Empieza tu prueba gratis de ${i?.days} día`);
	if (daysPlural === "other") return /** @type {LocalizedString} */ (`Empieza tu prueba gratis de ${i?.days} días`);
	return /** @type {LocalizedString} */ ("pricing_start_trial");
};

/**
* | output |
* | --- |
* | "Start {days}-day free trial" |
*
* @param {Pricing_Start_TrialInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_start_trial = /** @type {((inputs: Pricing_Start_TrialInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Start_TrialInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_start_trial(inputs)
	return en_pricing_start_trial(inputs)
});